import React from 'react';
import './Hero.css';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaGraduationCap, FaFlask, FaStethoscope } from 'react-icons/fa';

const heroImage = require('../../assets/images/naf-headshot.jpg');

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="container hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Your Path to Medical School Success</h1>
          <h2 className="hero-subheading">1-on-1 Guidance from a Current Resident Physician with Admissions Experience</h2>
          <p>
            Personalized guidance and strategic advice for high school, pre-medical, and medical students. Let us help you navigate your journey to becoming a physician.
          </p>
          <div className="hero-buttons">
            <motion.a
              href="#contact"
              className="btn btn-primary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Schedule a Free Consultation
            </motion.a>
            <motion.a
              href="#services"
              className="btn btn-secondary"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Our Services
            </motion.a>
          </div>
        </motion.div>
        <motion.div
          className="hero-image"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="image-container">
            <div className="placeholder-image">
                <img src={heroImage} alt="Nafis Eghrari - NafMedPrep Founder" className="hero-img" />
            </div>
          </div>
        </motion.div>
      </div>

      {/* Guidance at Every Stage Section */}
      <div className="journey-section">
        <div className="container">
          <motion.h2
            className="journey-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Guidance at Every Stage of Your Medical Journey
          </motion.h2>
          <div className="journey-stages">
            <motion.div
              className="journey-stage"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="stage-icon"><FaGraduationCap /></div>
              <h3>High School</h3>
              <p>Early planning, BS/MD program guidance, and building a competitive foundation for your pre-med journey.</p>
            </motion.div>
            <div className="journey-connector" />
            <motion.div
              className="journey-stage"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="stage-icon"><FaFlask /></div>
              <h3>Pre-Medical</h3>
              <p>Application strategy, personal statement crafting, activity optimization, and interview preparation.</p>
            </motion.div>
            <div className="journey-connector" />
            <motion.div
              className="journey-stage"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <div className="stage-icon"><FaStethoscope /></div>
              <h3>Medical Student</h3>
              <p>Research support, publication guidance, and academic mentorship to strengthen your residency application.</p>
            </motion.div>
          </div>
          <motion.div
            className="journey-cta"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <Link to="/contact" className="btn btn-primary">Book a Free Consultation</Link>
          </motion.div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="hero-stats-section">
        <div className="container">
          <div className="hero-stats-grid">
            <motion.div
              className="hero-stat"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <span className="hero-stat-number">100%</span>
              <span className="hero-stat-label">Acceptance Rate</span>
            </motion.div>
            <motion.div
              className="hero-stat"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <span className="hero-stat-number">75+</span>
              <span className="hero-stat-label">Students Mentored</span>
            </motion.div>
            <motion.div
              className="hero-stat"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <span className="hero-stat-number">8</span>
              <span className="hero-stat-label">Student Publications Supported</span>
            </motion.div>
          </div>
        </div>
      </div>

      <div className="hero-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
